import React, { useRef, useContext } from "react";
import { Form, Label, Input } from "reactstrap";
import { ApiContext } from "../apiContext";
import { Textarea } from "@mobiscroll/react-lite";

export default function AddForm({
  handleSubmit,
  formError,
  getInputValue,
  handleInputChange,
  handleImageUpload,
  handleClear,
  modalData,
  addCase,
  setModalData,
  setCase,
  closeModal,
  thumbnail_image_name,
}) {
  const { error } = useContext(ApiContext);

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="row edit-form">
          <div className="my-3 col-md-6">
            <Label for="page">Page</Label>
            <Input
              type="text"
              id="page"
              name="page"
              placeholder="Page"
              value={getInputValue("page")}
              onChange={(event) => handleInputChange(event, "page")}
            />
            <span className="non-valid">{formError.page}</span>
          </div>

          <div className="my-3 col-md-6">
            <Label htmlFor="title">Title</Label>
            <Input
              type="text"
              id="title"
              name="title"
              placeholder="Title"
              value={getInputValue("title")}
              onChange={(event) => handleInputChange(event, "title")}
            />
            <span className="non-valid">{formError.title}</span>
          </div>
          <div className="my-3 col-md-12">
            <Label htmlFor="description">Description</Label>
            <Textarea
              type="text"
              id="description"
              name="description"
              placeholder="Description"
              value={getInputValue("description")}
              onChange={(event) => handleInputChange(event, "description")}
            />
          </div>
          <div className="my-3 col-md-6">
            <Label htmlFor="embedurl">Video Url</Label>
            <Input
              type="text"
              id="embedurl"
              name="embedurl"
              placeholder="https://www.example.com/embed/123"
              value={getInputValue("embedurl")}
              onChange={(event) => handleInputChange(event, "embedurl")}
            />
            <span className="non-valid">{formError.embedurl}</span>
          </div>

          <div className="my-3 col-md-6">
            <Label htmlFor="imagefile">
              Select Image for Video (Upload only images up to 100kb)
            </Label>
            <div className="file-field">
              <div className="btn helensys-theme-btn btn-sm ml-0">
                <span>Choose File</span>
                <Input
                  id="documentuplad"
                  name="imagefile"
                  type="file"
                  onChange={(event) =>
                    handleImageUpload(event, "thumbnail_image")
                  }
                  accept="image/gif, image/jpeg, image/png, image/webp*"
                  encType="multipart/form-data"
                />
              </div>
              <div className="file-path-wrapper">
                <Input
                  className="file-path validate"
                  value={
                    modalData
                      ? modalData.thumbnail_image_name
                      : addCase.thumbnail_image_name
                  }
                  type="text"
                  placeholder=""
                  onChange={(event) =>
                    handleInputChange(event, "thumbnail_image_name")
                  }
                />
              </div>
            </div>
          </div>
          <div className="my-3 col-md-6">
            <Label htmlFor="status">Status</Label>
            <div className="toggle">
              <span>Inactive</span>
              <label
                className={`switch ${
                  (modalData && modalData.status) || addCase.status
                    ? "true"
                    : ""
                }`}
              >
                <Input
                  type="checkbox"
                  checked={modalData && modalData.status}
                  onChange={() => {
                    if (modalData) {
                      setModalData((prevModalData) => ({
                        ...prevModalData,
                        status: !prevModalData.status,
                      }));
                    } else {
                      setCase((prevAddCase) => ({
                        ...prevAddCase,
                        status: !prevAddCase.status,
                      }));
                    }
                  }}
                />
                <span className="slider round"></span>
              </label>
              <span>Active</span>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-warning ms-2"
              onClick={handleClear}
            >
              Clear
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-primary ms-2"
            >
              Submit
            </button>
          </div>
        </div>
      </Form>
    </>
  );
}
